import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OffCanvasMenu from "./OffCanvasMenu";
import { HiMenu, HiOutlineX } from "react-icons/hi";
import {
  navHomeOne,
  navHomeTwo,
  navCompanyLinks,
  navCompanyPage,
  navHomeThree,
  navHomeFour,
} from "./../../data";
const Navbar = ({
                  navDark,
                  insurance,
                  classOption,
                  corporate,
                  creativeAgencyOne,
                  itCompany,
                }) => {
  // console.log("corporate...", corporate);
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);

  useEffect(() => {
    const stickyheader = document.querySelector(".main-header");
    setHeaderTop(stickyheader.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  return (
      <>
        <header
            className={`main-header z-10 ${
                creativeAgencyOne ? "creative_agency_nav " : ""
            }  ${itCompany ? "it_company_nav " : ""}     ${
                corporate ? "header-35 position-absolute top-0 start-0 zindex-9" : ""
            }   ${navDark ? "position-absolute " : ""} w-100 ${classOption} ${
                insurance && "ins-header main-header w-100 z-10 "
            }`}
        >
          <nav
              className={`navbar navbar-expand-xl z-50  ${
                  corporate ? "affix" : ""
              } ${navDark ? "navbar-dark " : "navbar-light"} sticky-header ${
                  scroll > headerTop ? "affix" : ""
              }`}
          >
            <div className="container d-flex align-items-center justify-content-lg-between position-relative">
              <Link to="/">
                {scroll > headerTop || !navDark || itCompany ? (
                    <img
                        width={113}
                        height={36}
                        src="assets/img/logo-color.png"
                        alt="logo"
                        className="img-fluid logo-color"
                    />
                ) : (
                    <img
                        width={113}
                        height={36}
                        src="assets/img/logo_4.png"
                        alt="logo"
                        className="img-fluid logo-white"
                    />
                )}
              </Link>
              <button
                  className="navbar-toggler position-absolute right-0 border-0"
                  id="#offcanvasWithBackdrop"
                  role="button"
              >
              <span
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasWithBackdrop"
                  aria-controls="offcanvasWithBackdrop"
              >
                <HiMenu />
              </span>
              </button>
              <div className="clearfix"></div>
              <div className="collapse navbar-collapse justify-content-center">
                <ul className="nav col-12 col-md-auto justify-content-center main-menu">
                  <li className="nav-item dropdown">
                    <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                      Solutions
                    </a>
                    <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
                      <div className="dropdown-grid rounded-custom width-full">
                        <div className="dropdown-grid-item">
                          <h6 className="drop-heading">Products</h6>
                                <Link to="/online-payments" className="dropdown-link px-0">
                                  <span className="drop-title mb-0">
                                    Online Payments
                                  </span>
                                </Link>
                        </div>
                        <div className="dropdown-grid-item radius-right-side bg-light">
                          <h6 className="drop-heading">Services</h6>
                                <Link to="/payment-methods" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Global Payment Methods
                                  </span>
                                </Link>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                      Industries
                    </a>
                    <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
                      <div className="dropdown-grid rounded-custom">
                        <div className="dropdown-grid-item">
                          <h6 className="drop-heading">Industries</h6>
                          <Link to="/ecommerce" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    eCommerce
                                  </span>
                          </Link>
                          <Link to="/retail" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Retail
                                  </span>
                          </Link>
                          <Link to="/digital-goods" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Digital goods
                                  </span>
                          </Link>
                          <Link to="/financial-services" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Financial services
                                  </span>
                          </Link>
                          <Link to="/gaming" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Gaming
                                  </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                      Company
                    </a>
                    <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
                      <div className="dropdown-grid rounded-custom">
                        <div className="dropdown-grid-item">
                          <h6 className="drop-heading">Useful Links</h6>
                          <Link to="/about-us" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    About us
                                  </span>
                          </Link>
                          <Link to="/infrastructure" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Infrastructure
                                  </span>
                          </Link>
                          <Link to="/career" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Careers
                                  </span>
                          </Link>
                          <Link to="/events" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Events
                                  </span>
                          </Link>
                          <Link to="/request-demo" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Press and media
                                  </span>
                          </Link>
                          <Link to="/request-demo" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Licenses and certifications
                                  </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                      Resources
                    </a>
                    <div className="dropdown-menu border-0 rounded-custom shadow py-0 bg-white">
                      <div className="dropdown-grid rounded-custom width-full">
                        <div className="dropdown-grid-item">
                          <h6 className="drop-heading">Insights</h6>
                          <Link to="/request-demo" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Blog
                                  </span>
                          </Link>
                          <Link to="/request-demo" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    Videos
                                  </span>
                          </Link>
                        </div>
                        <div className="dropdown-grid-item radius-right-side bg-light">
                          <h6 className="drop-heading">Documentation</h6>
                          <Link to="/request-demo" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    API reference
                                  </span>
                          </Link>
                          <Link to="/faq" className="dropdown-link">
                                  <span className="drop-title mb-0">
                                    FAQ
                                  </span>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="action-btns text-end me-5 me-lg-0 d-none d-md-block d-lg-block">

                  <div className='row'>
                      {/*<div className='col-lg-6 col-md-12'>*/}
                      {/*    <Link*/}
                      {/*        to="/contact-us"*/}
                      {/*        className={*/}
                      {/*            insurance ? "ins-btn ins-primary-btn" : "btn btn-primary"*/}
                      {/*        }*/}
                      {/*    >*/}
                      {/*        Contact Us*/}
                      {/*    </Link>*/}
                      {/*</div>*/}
                      <div className='col-lg-6 col-md-12'>
                          <Link
                              to="/contact-us"
                              className={
                                  insurance ? "btn btn-link text-decoration-none me-2" : "btn btn-link text-decoration-none me-2"
                              }
                          >
                              Contact Us
                          </Link>
                      </div>
                      <div className='col-lg-5 col-md-12'>
                          <Link
                              to="/contact-external-system"
                              className={
                                  insurance ? "ins-btn ins-primary-btn" : "btn btn-primary"
                              }
                          >
                              Log in
                          </Link>
                      </div>
                  </div>


              </div>

              <div
                  className="offcanvas offcanvas-end d-xl-none"
                  tabIndex="-1"
                  id="offcanvasWithBackdrop"
              >
                <div className="offcanvas-header d-flex align-items-center mt-4">
                  <Link
                      to="/"
                      className="d-flex align-items-center mb-md-0 text-decoration-none"
                  >
                    <img
                        width={121}
                        height={36}
                        src="/logo-color.png"
                        alt="logo"
                        className="img-fluid ps-2"
                    />
                  </Link>
                  <button
                      type="button"
                      className="close-btn text-danger"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                  >
                    <HiOutlineX />
                  </button>
                </div>

                {/* <OffCanvasMenu /> */}
              </div>
            </div>
          </nav>
        </header>
      </>
  );
};

export default Navbar;
